import { features } from "../../../mocks/guaData";

const featureBg: Record<string, string> = {
  "bg-accent-500": "bg-accent-500",
  "bg-primary-500": "bg-primary-500",
  "bg-secondary-500": "bg-secondary-500",
};

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-100 py-14 md:py-20" aria-label="核心功能">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="text-sm font-semibold uppercase tracking-wider text-accent-600">Features</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              六项核心能力，撑起完整的吃瓜体验
            </h2>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              从发现热点到深挖脉络再到沉淀收藏，吃瓜神器用一套组合拳，
              帮你把追热点这件事做得又快又爽。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <article
              key={f.title}
              className="group rounded-lg bg-background-50 p-6 ring-1 ring-background-200 transition-colors hover:ring-primary-300"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg text-xl text-white ${featureBg[f.color]}`}
              >
                <i className={f.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}